module.exports = __webpack_public_path__ + "img/1703.cb03377f.jpg";